import { AuthenticationService } from './../../servicios/authentication.service';
import { formatDateForBackend } from '../../shared/utilerias/utils';
import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { AguaDescuentosService } from "../../servicios/agua-descuentos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { AguaDescuentos, CatConceptos, Privilegios, RRequisitosDescuentos } from "../../entidades/entidades";
import { Aguas, CargosDetalles, CargosDetallesInput, EstadoCuentaInformacionInput, RAguasPersonas, CatUsuarios, Personas, RegistroBitacoraInput } from "../../entidades/entidades";
import { Observable } from "rxjs";
import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";
import { CatUsuariosService } from '../../../app/servicios/cat-usuarios.service';
import { CatRequisitosService } from "../../servicios/cat-requisitos.service";
import { CatConceptosDescuentosService } from "../../servicios/cat-concepto-descuentos.service";
import { CargosDetallesService } from "../../servicios/cargos-detalles.service";
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { Router } from '@angular/router';
import { PrivilegiosService } from 'app/servicios/privilegios.service';

@Component({
    selector: "app-agua-descuentos",
    templateUrl: "./agua-descuentos.component.html",
    styleUrls: ["./agua-descuentos.component.css"],
})
export class AguaDescuentosComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    aguaDescuentos: AguaDescuentos[];
    itemsMenu: MenuItem[];
    columnasTabla: any[];
    clonedAguaDescuentos: { [s: string]: AguaDescuentos } = {};
    public aguaDesc: AguaDescuentos;

    public aguaBloqueos: AguaDescuentos[];
    public rRequisitosDescuentos: RRequisitosDescuentos[];
    public aguas$: Observable<Aguas>;
    public aguasLimpio: Aguas;
    public idAguasProceso: number;

    public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
    public cargosDetallesInputLimpio: CargosDetallesInput;
    public cargosDetalles: CargosDetalles;

    public estadoCuentaInformacionInput$ = new EventEmitter<
        EstadoCuentaInformacionInput>();
    public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;

    public usuario: any;
    public rAguasPersonas: RAguasPersonas;
    public personas$: Observable<Personas>;
    public personasLimpio: Personas;
    numNomina: string;
    numNominaFlag: boolean = false;
    usuariosSelec: SelectItem[];
    requisitos: SelectItem[];
    catConcepto: SelectItem[];
    privilegiosFechaFinal: Boolean = false;
    catConceptoFinal: CatConceptos[];
    public usuarios: CatUsuarios[];
    public registroBitacora = new RegistroBitacoraInput();

    public progressBar = false;
    showBar() {
        this.progressBar = true;
    }

    value: Date;
    es: any;

    constructor(
        private cargosDetallesService: CargosDetallesService,
        private aguaDescuentosService: AguaDescuentosService,
        private aguasService: AguasService,
        private router: Router,
        private privilegiosService: PrivilegiosService,
        private rAguasPersonasService: RAguasPersonasService,
        private personasService: PersonasService,
        private catUsuariosService: CatUsuariosService,
        private requisitosService: CatRequisitosService,
        private catConceptosDescuentosService: CatConceptosDescuentosService,
        private authenticationService: AuthenticationService,
        private registroBitacoraService: RegistroBitacoraService,
    ) { }

    // prettier-ignore
    async ngOnInit() {
        //this.getAguaDescuentos();
        
        await this.getAllCatConceptos();
        await this.getPrivilegios();

        await this.authenticationService.getUserByToken();
        this.usuario = this.authenticationService.currentUserValue;

        this.es =
        {
            firstDayOfWeek: 0,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
            today: 'Hoy',
            clear: 'Borrar'
        };
        // ===============================================================
        //Opciones del menu
        // ===============================================================
        this.itemsMenu = [
            { label: "Agrega Descuento", icon: "pi pi-file-o", command: () => this.add(), },
            { label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridAguaDescuentos(); }, disabled: this.progressBar },
            { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAguaDescuentos(this.aguaDesc); }, },
        ];

        // ===============================================================
        //Opciones de la tabla
        // ===============================================================
        this.columnasTabla = [
            { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;", },
            { field: "acciones", header: "", ordenar: false, styleHeader: "width: 30px;", },
            { field: "idConcepto", header: "Campaña", ordenar: false, styleHeader: "width: 180px;", },
            { field: "idRequisito", header: "Documento Acreditación", ordenar: false, styleHeader: "width: 370px;", },
            { field: "vigenciaIni", header: "Fecha Inicial", ordenar: false, styleHeader: "width: 180px;", },
            { field: "vigenciaFin", header: "Fecha Final", ordenar: false, styleHeader: "width: 180px;", },
            { field: "idUsuario", header: "Usuario Asignó", ordenar: false, styleHeader: "width: 180px;", },
            { field: "observaciones", header: "Observaciones", ordenar: false, styleHeader: "width: 200px;", },
        ];
    }
    //===============================================================
    //Agrega renglon en el grid
    //===============================================================
    add() {

        // debugger;

        if (this.aguaDescuentos.length > 0) {
            this.muestraMensaje.error("Solo se permite un descuento", "top", "center");
            return;
        } else {
            let aguaDescuentosNew = new AguaDescuentos();
            aguaDescuentosNew.cambio = true;
            aguaDescuentosNew.id = 0;
            aguaDescuentosNew.idAgua = this.aguaDesc.idAgua;
            aguaDescuentosNew.idUsuario = this.usuario.id;
            this.aguaDescuentos = [];
            this.aguaDescuentos.unshift(aguaDescuentosNew);
        }

    }

    //===============================================================
    //Funciones de la tabla
    //===============================================================
    onEditInit(event) {
        let aguaDescuentosEdit = event.data;

        this.clonedAguaDescuentos[aguaDescuentosEdit.numRow] = { ...aguaDescuentosEdit };
        aguaDescuentosEdit.cambio = true;
        aguaDescuentosEdit.baja = false;
    }

    onEditCancel(event) {
        let aguaDescuentosEdit = event.data;
        let index = this.aguaDescuentos.findIndex(
            (obj) => obj.numRow === aguaDescuentosEdit.numRow
        );
        this.aguaDescuentos[index] = {
            ...this.clonedAguaDescuentos[aguaDescuentosEdit.numRow],
        };
    }

    onDelete(event, index: number) {
        event.cambio = false;
        event.baja = true;
    }

    async onEditComplete(event) {
        try {
            let aguaDescuentosEdit = event.data;

            this.checaaEmpleados(aguaDescuentosEdit);


            //Valida si hay cambios
            if (
                aguaDescuentosEdit.observaciones ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].observaciones &&
                aguaDescuentosEdit.idRequisito ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].idRequisito &&
                aguaDescuentosEdit.idConcepto ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].idConcepto &&
                aguaDescuentosEdit.vigenciaIni ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].vigenciaIni &&
                aguaDescuentosEdit.nomina ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].nomina &&
                aguaDescuentosEdit.vigenciaFin ===
                this.clonedAguaDescuentos[aguaDescuentosEdit.numRow].vigenciaFin
            ) {
               let index = this.aguaDescuentos.findIndex(
                    (obj) => obj.numRow === aguaDescuentosEdit.numRow
                );
                this.aguaDescuentos[index] = {
                    ...this.clonedAguaDescuentos[aguaDescuentosEdit.numRow],
                };
                return;
            }


            var date = new Date(aguaDescuentosEdit.vigenciaIni);
            var dayActual = '31';
            var monthIndexActual = '12';
            var yearActual = date.getFullYear();
            var fecha_act = null;
            if (aguaDescuentosEdit.vigenciaIni) {
                fecha_act = yearActual.toString() + "-" + monthIndexActual.toString() + "-" + dayActual.toString() + "T00:00:00";
                if (!aguaDescuentosEdit.vigenciaFin)
                    aguaDescuentosEdit.vigenciaFin = new Date(fecha_act);
            }


            //Validaciones
            //throw new Error("No paso las validaciones.");

            aguaDescuentosEdit.cambio = true;
            aguaDescuentosEdit.baja = false;
            
        
        
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por onEditComplete");
        }
    }

    async buscaNomina(nomina: string, idAgua: number){
        try {

            //checamos el numero de nomina
            const datoRetorno = await this.aguaDescuentosService.getNomina(nomina,idAgua).toPromise();
          
            if(Object.keys(datoRetorno).length > 0)  return true;
            else return false;

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.progressBar = false;
            console.log("Paso por guardarAguaDescuentos");
        }
    }


    //===============================================================
    //Interaccion con servicios
    //===============================================================
    async guardarGridAguaDescuentos() {
        this.showBar();
        try {
            for (let aguaDescuentosFor of this.aguaDescuentos) {
           
                if (aguaDescuentosFor.baja) {
                    await this.deleteAguaDescuentos(aguaDescuentosFor);
                } else if (aguaDescuentosFor.cambio) {
                    if (aguaDescuentosFor.id === 0) {
                        if(this.numNominaFlag) {
                            if(aguaDescuentosFor.nomina == null) 
                            {
                                this.muestraMensaje.error("Ingrese el número nomina.", "top", "center");
                                return;
                            }
                            var busqueda = await this.buscaNomina(aguaDescuentosFor.nomina, aguaDescuentosFor.idAgua);
                           
                            if(busqueda) 
                            {
                                this.muestraMensaje.error("Este número de nomina ya esta asignado a otro descuento.", "top", "center");
                                return;
                            }
                            
                        }
                        aguaDescuentosFor.idUsuario = this.usuario.id;
                        const datoRetorno = await this.addAguaDescuentos(aguaDescuentosFor);
                        aguaDescuentosFor.id = datoRetorno.id;
                    } else {
                        if(this.numNominaFlag) {
                            if(aguaDescuentosFor.nomina == null) 
                            {
                                this.muestraMensaje.error("Ingrese el número nomina.", "top", "center");
                                return;
                            }
                            var busqueda = await this.buscaNomina(aguaDescuentosFor.nomina, aguaDescuentosFor.idAgua);
                           

                            if(busqueda) 
                            {
                                this.muestraMensaje.error("Este número de nomina ya esta asignado a otro descuento.", "top", "center");
                                return;
                            }
                            
                        }
                        await this.updateAguaDescuentos(aguaDescuentosFor);
                    }
                    aguaDescuentosFor.cambio = false;
                }
            }

            {
                // Ejecuta calculo
                let cargosDetallesInput = new CargosDetallesInput();
                cargosDetallesInput.idAgua = this.idAguasProceso;
                cargosDetallesInput.idEstatus = 1;
                cargosDetallesInput.idUsuarioGuardo = this.usuario.id;
                cargosDetallesInput.conEstimadoAnual = false;
                cargosDetallesInput.ejecutaCalculo = true;
                cargosDetallesInput.borrarEstimado = true;
                await this.cargosDetallesService
                    .getBusquedas(cargosDetallesInput)
                    .toPromise();
            }

            {
                //Actualiza formulario estado-cuentas, despues del calculo
                let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
                estadoCuentaInformacionInput.idAgua = this.idAguasProceso;
                //estadoCuentaInformacionInput.cuentaAgua = this.aguasProceso.cuentaAgua;
                await this.estadoCuentaInformacionInput$.emit(
                    estadoCuentaInformacionInput
                );
            }

            this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.progressBar = false;
            console.log("Paso por guardarAguaDescuentos");
        }
    }
    getRequisitoLabels(ids: number[]): string {
        if (!ids || ids.length === 0) {
            return 'No hay requisitos seleccionados';
        }
        return ids
            .map(id => this.requisitos.find(req => req.value === id)?.label || 'Desconocido')
            .join(', ');
    }
    
    
    async addAguaDescuentos(aguaDescuentos) {
        try {

            const aguaDescuentosCopy = { ...aguaDescuentos };
            aguaDescuentosCopy.vigenciaIni = formatDateForBackend(aguaDescuentosCopy.vigenciaIni);
            aguaDescuentosCopy.vigenciaFin = formatDateForBackend(aguaDescuentosCopy.vigenciaFin);
            const datoretorno = await this.aguaDescuentosService.add(aguaDescuentosCopy).toPromise();
            debugger;

            this.getAguaDescuentos(this.aguaDesc);
            return datoretorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por addAguaDescuentos");
        }
    }

    async getAguaDescuentos(agua: AguaDescuentos) {
        try {
          const datoRetorno = await this.aguaDescuentosService.getSingle(agua.idAgua).toPromise();
          this.aguaDescuentos = datoRetorno;

          debugger;
      
          for (let i = 0, len = this.aguaDescuentos.length; i < len; ++i) {
            const descuento = this.aguaDescuentos[i];
            descuento.numRow = i;
            this.clonedAguaDescuentos[descuento.numRow] = { ...descuento };
      
            // Obtener los requisitos asociados al descuento
            const requisitos = await this.getRequisitosDescuento(descuento.id);
      
            // Asignar los requisitos al campo `idRequisito`
            descuento.idRequisito = requisitos.map((req: RRequisitosDescuentos) => req.idRequisito);
      
            this.checaaEmpleados(descuento);
          }
        } catch (e) {
          if (e.response) throw { message: e.response.data };
          else throw e;
        } finally {
          console.log("Paso por getAguaDescuentos");
        }
    }
    // Método para obtener requisitos asociados al descuento
    async getRequisitosDescuento(idDescuento: number): Promise<any[]> {
        try {
            const requisitos = await this.aguaDescuentosService.getRequisitosByDescuento(idDescuento).toPromise();
            return requisitos; // Devuelve los requisitos obtenidos
        } catch (error) {
            console.error('Error obteniendo requisitos del descuento:', error);
            return [];
        }
    }
    async checaaEmpleados(aguaDescuentos: AguaDescuentos){
         //Buscamos si el descuento es de empleados

         var auxBusqueda = this.catConceptoFinal.find(x => x.id === aguaDescuentos.idConcepto );

         if(auxBusqueda?.reqNomina){
             const indicenumNomina = this.columnasTabla.findIndex(columna => columna.field === "numNomina");

             // Si se encuentra el objeto con field: "observaciones", eliminarlo
             if (indicenumNomina == -1) {
                 this.columnasTabla.push({ field: "numNomina", header: "Núm. Nomina", ordenar: false, styleHeader: "width: 200px;", },);
             }
             
             this.numNominaFlag = true;
         
         }
         else {
             // Encontrar el índice del objeto con field: "observaciones"
             const indiceObservaciones = this.columnasTabla.findIndex(columna => columna.field === "numNomina");

             // Si se encuentra el objeto con field: "observaciones", eliminarlo
             if (indiceObservaciones !== -1) {
                 this.columnasTabla.splice(indiceObservaciones, 1);
             }
             this.numNominaFlag = false;
             aguaDescuentos.nomina = null; 

         }
    }

    async updateAguaDescuentos(aguaDescuentos: AguaDescuentos) {
        try {
            for (let aguaDescuentosFor of this.aguaDescuentos) {
                if (aguaDescuentos.vigenciaIni > aguaDescuentosFor.vigenciaIni && aguaDescuentos.vigenciaIni < aguaDescuentosFor.vigenciaFin) {
                    throw new Error("Ya existe un descuento con este rango de fechas.");
                }
                if (aguaDescuentos.vigenciaFin > aguaDescuentosFor.vigenciaIni && aguaDescuentos.vigenciaFin < aguaDescuentosFor.vigenciaFin) {
                    throw new Error("Ya existe un descuento con este rango de fechas.");
                }
                if (aguaDescuentos.vigenciaIni < aguaDescuentosFor.vigenciaIni && aguaDescuentos.vigenciaFin > aguaDescuentosFor.vigenciaFin) {
                    throw new Error("Ya existe un descuento con este rango de fechas.");
                }
            }

            // Crear una copia del objeto para no afectar el input tipo date original.
            const aguaDescuentosCopy = { ...aguaDescuentos };
            aguaDescuentosCopy.vigenciaIni = formatDateForBackend(aguaDescuentosCopy.vigenciaIni);
            aguaDescuentosCopy.vigenciaFin = formatDateForBackend(aguaDescuentosCopy.vigenciaFin);
            const datoRetorno = await this.aguaDescuentosService.update(aguaDescuentosCopy).toPromise();
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por updateAguaDescuentos");
        }
    }

    async deleteAguaDescuentos(aguaDescuentos: AguaDescuentos) {
        try {
            const datoRetorno = await this.aguaDescuentosService
                .delete(aguaDescuentos.id)
                .toPromise();
            this.getAguaDescuentos(this.aguaDesc);

            this.registroBitacora.idAgua = this.aguaDesc.idAgua;
            this.registroBitacora.accion = "SE QUITO UN DESCUENTO";
            await this.registroBitacoraService.add(this.registroBitacora).toPromise();

        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por deleteAguaDescuentos");
        }
    }

    // =====================================================
    //Carga principal
    // =====================================================
    async childAguaBuscaCuentas(idAgua: number) {
        try {
            this.idAguasProceso = idAgua;

            this.limpiaInput();
            if (!this.idAguasProceso) {
                this.aguas$ = await this.aguasService.getSingle(0);
                this.personas$ = await this.personasService.getSingle(0);

                this.limpiaInput();
                return;
            }

            // carga formulario de agua
            this.aguas$ = await this.aguasService.getSingle(idAgua);

            //Carga formulario de personas
            const rAguasPersonasBusquedas = new RAguasPersonas();
            rAguasPersonasBusquedas.idAgua = idAgua;
            await this.getRAguasPersonas(rAguasPersonasBusquedas);
            this.personas$ = await this.personasService.getSingle(
                this.rAguasPersonas.idPersona
            );

           

            //Carga formulario estado-cuentas
            let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
            estadoCuentaInformacionInput.idAgua = idAgua;
            //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
            await this.estadoCuentaInformacionInput$.emit(
                estadoCuentaInformacionInput
            );

            this.aguaDesc = new AguaDescuentos();
            this.aguaDesc.idAgua = idAgua;
            this.getAguaDescuentos(this.aguaDesc);

            this.getCatUsuarios();
            this.getCatRequisitos();
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childAguas");
        }
    }

    async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
        try {
            const datoRetorno = await this.rAguasPersonasService
                .getBusquedas(rAguasPersonas)
                .toPromise();
            this.rAguasPersonas = datoRetorno[0];
            
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getRAguasPersonas");
        }
    }

    async getCatRequisitos() {
        const datoRetorno = await this.requisitosService.getAll().toPromise();

        const datosR = datoRetorno.filter((x) => x.id);
       
        this.requisitos = datosR.map((datos) => {
            return { label: datos.descripcion, value: datos.id };
        });
    }

    async getCatUsuarios() {
        try {
            this.usuarios = [];
            let datoRetorno = await this.catUsuariosService
                .getAll()
                .toPromise();
            this.usuarios = datoRetorno;
            this.usuariosSelec = datoRetorno.map((datos) => {
                return { label: datos.nombre, value: datos.id };
            });
            debugger;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getCatUsuarios");
        }
    }

    async getAllCatConceptos() {
        try {
            const datoRetorno = await this.catConceptosDescuentosService
                .getAll()
                .toPromise();
            this.catConceptoFinal = datoRetorno;
            this.catConcepto = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id, reqNomina:  datos.reqNomina};
            });
            this.catConcepto.unshift({ label: "SELECCIONA...", value: null });
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getAllCatConceptos");
        }
    }

    limpiaInput() {
        this.estadoCuentaInformacionInput$.emit(null);
        this.cargosDetallesInput$.emit(null);
    }

        async getPrivilegios() {
          try {
      
            let objUrl = new Privilegios();
            objUrl.descripcion = this.router.url + '/fecha-descuentos';
            let fechaFinal = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
            this.privilegiosFechaFinal = fechaFinal ? true : false; 
    
          } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
          } finally {
            console.log("Paso por getPrivilegios");
          }
        }
}
